import { api } from "@/lib/api";

export const listContacts = (filter) => api.get("/admin/contacts", { params: { filter } }).then((r) => r.data);
export const contactDetail = (email) => api.get("/admin/contacts/detail", { params: { email } }).then((r) => r.data);
export async function downloadSubscribersCsv() {
  const r = await api.get("/admin/contacts/subscribers.csv", { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = Object.assign(document.createElement("a"), { href: url, download: "newsletter-subscribers.csv" });
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export const NEWS = {
  subscribed: ["Subscribed", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  unsubscribed: ["Unsubscribed", "bg-red-50 text-red-700 border-red-200"],
  not_subscribed: ["Not subscribed", "bg-stone-50 text-stone-600 border-stone-200"],
};
export const fmtDT = (v) => (v ? new Date(v).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" }) : "—");
export const fmtDay = (v) => (v ? new Date(v).toLocaleDateString(undefined, { dateStyle: "medium" }) : "—");
